import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { Bo } from '@teetsh/app/src/types/bo';

export const BO_KEY = 'bo';

function getBo(boId: string) {
  const requestURL = `/bos/${boId}`;
  return request(requestURL, {
    method: 'GET',
  }).then<Bo>(p => p);
}

export default function useBo(boId: string) {
  return useQuery({
    queryKey: [BO_KEY, boId],
    queryFn: () => getBo(boId),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60,
  });
}
